
export const serverAppConfig = {
  "storeId": "681c90ea7abcc5e440fd5ec0",
  "categories": [
    {
      "id": "68595fc57b37a240465b54f4",
      "name": "Webshop",
      "slug": "webshop",
      "description": "Reijmyre Glasbruk – munblåst glas sedan 1810. Upptäck tidlöst svenskt hantverk, formgivet av ledande designers och skapat av skickliga glasblåsare i hjärtat av Östergötland. I vår webshop hittar du handgjorda glas, vaser och skålar som förenar tradition, kvalitet och modern design",
      "thumbnailDescription": "Upptäck Reijmyre Glasbruks tidlösa hantverk i vår webshop. Handgjorda glas, vaser och skålar sedan 1810.",
      "additionalText": "<p>Reijmyre Glasbruk har varit en symbol för svenskt hantverk i över två århundraden. Våra produkter är formgivna av ledande designers och tillverkade med precision och passion av våra erfarna glasblåsare. Besök vår webshop för att se vårt utbud av exklusiva glasprodukter som förenar traditionell teknik med modern estetik. Perfekt för både samlare och de som söker unika inredningsdetaljer.</p>",
      "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1074/tags/14.jpg",
      "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1074/tags/14.jpg",
      "order": 1,
      "metaTitle": "Reijmyre Glasbruk: Tidlöst Svenskt Hantverk Sedan 1810",
      "metaDescription": "Utforska Reijmyre Glasbruks unika kollektion av munblåst glas. Handgjorda glas, vaser och skålar som kombinerar tradition och modern design, skapade av skickliga glasblåsare i Östergötland.",
      "metaHeader": "Reijmyre Glasbruk – Traditionellt och Modernt Glas",
      "subCategories": [
        {
          "id": "68638734c148796284f49b1c",
          "name": "Serviser",
          "slug": "webshop-serviser",
          "description": "Upptäck Reijmyres handgjorda dricksglas – från klassiska vinglas och champagneglas till moderna vardagsglas. Varje glas är munblåst av våra skickliga glasblåsare i Rejmyre och bär på över 200 års svenskt hantverk och designtradition. En servis från Reijmyre är skapad för att användas, älskas och gå i arv.",
          "thumbnailDescription": "Upptäck Reijmyres munblåsta glas – en tradition av svenskt hantverk.",
          "additionalText": "<p>Reijmyres glas är inte bara vackra att se på, de är också skapade för att användas och älskas i generationer. Vår webshop erbjuder ett brett utbud av serviser som passar alla tillfällen, från festliga middagar till vardagliga stunder. Varje glas är ett konstverk i sig, med en historia av över 200 års hantverk och design. Välj Reijmyre för en tidlös elegans och kvalitet som varar.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1074/tags/14.jpg",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1074/tags/14.jpg",
          "order": 1,
          "metaTitle": "Reijmyres Handgjorda Dricksglas – Svenskt Hantverk i Världsklass",
          "metaDescription": "Utforska Reijmyres unika kollektion av handgjorda dricksglas, inklusive klassiska vinglas, champagneglas och moderna vardagsglas. Varje glas är munblåst av skickliga glasblåsare i Rejmyre och representerar över 200 års svensk hantverkstradition.",
          "metaHeader": "Reijmyres Handgjorda Dricksglas",
          "subCategories": null
        },
        {
          "id": "6863a9b8c148796284f49b1e",
          "name": "Kannor och Karaffer",
          "slug": "webshop-kannor-och-karaffer",
          "description": "Reijmyres handblåsta kannor och karaffer förenar funktion och estetik. Varje del är munblåst av våra skickliga glasblåsare och bär spår av det genuina hantverk som kännetecknar glasbruket sedan 1810. Perfekta för vatten, vin eller festliga tillfällen – och lika vackra som inredningsdetaljer.",
          "thumbnailDescription": "Traditionellt hantverk och tidlös skönhet i varje handblåst kanna och karaff från Reijmyre.",
          "additionalText": "<p>Reijmyres glasbruk har varit en symbol för kvalitet och tradition sedan 1810. Våra handblåsta kannor och karaffer är inte bara praktiska för servering av vatten och vin, utan de är också konstverk i sig själva. Varje produkt är unik, skapad med omsorg och expertis av våra erfarna glasblåsare. Dessa kannor och karaffer är perfekta för både vardag och fest, och de tillför en touch av elegans till ditt hem. Utforska vår kollektion och upplev skönheten i äkta svenskt hantverk.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1074/tags/14.jpg",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1074/tags/14.jpg",
          "order": 2,
          "metaTitle": "Reijmyres Handblåsta Kannor och Karaffer - Traditionellt Hantverk sedan 1810",
          "metaDescription": "Upptäck Reijmyres unika handblåsta kannor och karaffer, där funktion möter estetik. Varje del är skapad av våra skickliga glasblåsare och bär på en rik historia av genuint hantverk. Perfekta för alla tillfällen och som vackra inredningsdetaljer.",
          "metaHeader": "Reijmyres Handblåsta Kannor och Karaffer",
          "subCategories": null
        },
        {
          "id": "6863a9d5a5b63c77b2ef9661",
          "name": "Vaser och Krukor",
          "slug": "webshop-vaser-och-krukor",
          "description": "Upptäck tidlösa vaser och krukor från Reijmyre – munblåsta i glas med en unik karaktär. Skapade för att framhäva blommor och växter lika mycket som för att stå som konstverk i sig själva. Traditionellt svenskt glasbruk möter modern design i varje form.",
          "thumbnailDescription": "Upptäck unika, munblåsta vaser och krukor från Reijmyre. Perfekta för att framhäva blommor eller som konstverk.",
          "additionalText": "<p>Reijmyre Glasbruk har en lång tradition av att skapa glasprodukter av högsta kvalitet. Varje vas och kruka är ett resultat av skickligt hantverk och modern design, vilket gör dem till ett perfekt tillskott i ditt hem. Oavsett om du letar efter något för att komplettera din inredning eller en gåva som verkligen sticker ut, erbjuder vår kollektion något för alla smaker.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1074/tags/14.jpg",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1074/tags/14.jpg",
          "order": 3,
          "metaTitle": "Tidlösa Vaser och Krukor från Reijmyre – Munblåst Glas",
          "metaDescription": "Utforska vår kollektion av vaser och krukor från Reijmyre, där traditionellt svenskt glasbruk möter modern design. Varje munblåst verk är skapat för att framhäva blommor och växter, samtidigt som de står som konstverk i sig själva.",
          "metaHeader": "Reijmyre Vaser och Krukor – Tradition och Design i Perfekt Harmoni",
          "subCategories": null
        },
        {
          "id": "6863a9f4c148796284f49b1f",
          "name": "Ljuslyktor",
          "slug": "webshop-ljuslyktor",
          "description": "Låt Reijmyres munblåsta ljuslyktor sprida värme och stämning i ditt hem. Varje lykta är unik, skapad för hand av glasblåsare som fört hantverket vidare i generationer. En perfekt gåva eller detalj som förvandlar vardag till högtid.",
          "thumbnailDescription": "Låt Reijmyres ljuslyktor förvandla ditt hem med unik värme och stämning.",
          "additionalText": "<p>Reijmyres ljuslyktor är mer än bara en inredningsdetalj; de är konstverk skapade med omsorg och tradition. Varje lykta bär på en historia av hantverksskicklighet och passion, vilket gör dem till en idealisk present eller en personlig touch i ditt hem. Utforska vårt sortiment och hitta den perfekta lyktan som passar just din stil och smak.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1074/tags/14.jpg",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1074/tags/14.jpg",
          "order": 4,
          "metaTitle": "Reijmyres Munblåsta Ljuslyktor - Unik Värme och Stämning",
          "metaDescription": "Upptäck Reijmyres handgjorda ljuslyktor som sprider värme och stämning i ditt hem. Varje lykta är unik och skapad av skickliga glasblåsare med generationer av hantverkstradition. Perfekt som gåva eller för att förvandla vardagen till en högtid.",
          "metaHeader": "Reijmyres Unika Munblåsta Ljuslyktor",
          "subCategories": null
        },
        {
          "id": "6863aa16c148796284f49b20",
          "name": "Fat och Skålar",
          "slug": "webshop-fat-och-skalar",
          "description": "Från servering till dekoration – Reijmyres fat och skålar är handblåsta original som bär på över 200 års glasblåstradition. Varje del är skapad för att användas och älskas, generation efter generation.",
          "thumbnailDescription": "Handblåsta fat och skålar från Reijmyre – en hyllning till glasblåstradition.",
          "additionalText": "<p>Reijmyres fat och skålar är mer än bara bruksföremål; de är konstverk skapade med omsorg och skicklighet. Varje del är unik, blåst för hand av våra erfarna glasblåsare. Dessa föremål är inte bara funktionella utan också en del av en rik historia som sträcker sig över två århundraden. Perfekta för att ge ditt hem en touch av elegans och tradition.</p>",
          "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1074/tags/14.jpg",
          "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1074/tags/14.jpg",
          "order": 5,
          "metaTitle": "Reijmyres Handblåsta Fat och Skålar – Tradition och Elegans",
          "metaDescription": "Upptäck Reijmyres unika kollektion av handblåsta fat och skålar. Med över 200 års glasblåstradition erbjuder vi tidlösa original som förgyller både servering och dekoration. Perfekta för att älskas och användas i generationer.",
          "metaHeader": "Reijmyres Fat och Skålar: En Tradition av Skönhet",
          "subCategories": null
        }
      ]
    },
    {
      "id": "68625832f363073c0c425231",
      "name": "Om våra Formgivare",
      "slug": "om-vara-formgivare",
      "description": "Bakom varje glas från Reijmyre står en formgivare med en egen vision och känsla för materialet. Här möter du de designers som tillsammans med våra glasblåsare skapat unika kollektioner – från klassiska serviser till moderna konstobjekt. Upptäck hur svensk designtradition och individuella uttryck förenas i munblåst glas från Reijmyre.",
      "thumbnailDescription": "Möt formgivarna bakom Reijmyres unika glasdesign, där tradition och innovation förenas.",
      "additionalText": "<p>Reijmyre Glasbruk är en plats där kreativitet och hantverk möts. Våra formgivare arbetar nära våra skickliga glasblåsare för att skapa kollektioner som inte bara är vackra att se på, utan också bär på en historia. Varje glas är ett resultat av en formgivares vision och en hyllning till den svenska designtraditionen. Oavsett om du letar efter en klassisk servis eller ett modernt konstobjekt, erbjuder Reijmyre något för alla smaker. Upptäck skönheten i munblåst glas och låt dig inspireras av våra unika skapelser.</p>",
      "imgUrl": null,
      "thumbnailUrl": null,
      "order": 2,
      "metaTitle": "Upptäck Reijmyres Unika Glasdesign: Tradition Möter Innovation",
      "metaDescription": "Utforska Reijmyres värld av munblåst glas där svensk designtradition och individuella uttryck förenas. Möt formgivarna bakom våra unika kollektioner, från klassiska serviser till moderna konstobjekt.",
      "metaHeader": "Reijmyre Glas: Tradition och Innovation i Perfekt Harmoni",
      "subCategories": null
    },
    {
      "id": "6862589236748b544ef0cf44",
      "name": "Boka Upplevelser",
      "slug": "boka-upplevelser",
      "description": "På Reijmyre Glasbruk får du mer än ett besök – du får en upplevelse. Här kan du följa glasblåsarnas arbete på nära håll, delta i guidade visningar och själv prova på att blåsa glas. En levande inblick i hantverk, historia och skaparglädje som stannar kvar länge.",
      "thumbnailDescription": "Följ glasblåsarnas konst på nära håll och delta i skaparglädjen på Reijmyre Glasbruk.",
      "additionalText": "<p>Reijmyre Glasbruk erbjuder en unik möjlighet att uppleva glasblåsningens konst på nära håll. Här kan du inte bara se mästarna i arbete, utan även delta i guidade visningar som ger en djupare förståelse för glasets historia och hantverk. För den som vill ta det ett steg längre finns även chansen att själv prova på att blåsa glas, en aktivitet som garanterat lämnar ett bestående intryck. Oavsett om du är en entusiast av hantverk eller bara nyfiken på att lära dig något nytt, är ett besök på Reijmyre Glasbruk en upplevelse du sent kommer att glömma.</p>",
      "imgUrl": null,
      "thumbnailUrl": null,
      "order": 3,
      "metaTitle": "Upptäck Glasblåsningens Magi på Reijmyre Glasbruk",
      "metaDescription": "Besök Reijmyre Glasbruk för en unik upplevelse där du kan se glasblåsare i arbete, delta i guidade turer och prova på att blåsa glas själv. En oförglömlig inblick i hantverk och historia.",
      "metaHeader": "Reijmyre Glasbruk: En Oförglömlig Glasupplevelse",
      "subCategories": null
    },
    {
      "id": "68625925c148796284f49b0f",
      "name": "Om oss",
      "slug": "om-oss",
      "description": "Upptäck Reijmyre Glasbruk – en levande hantverksby mitt i Östergötlands vackra natur. Här möts du av glashyttans magi, butikens unika sortiment och ett rikt utbud av kultur och lokala samarbeten som gör varje besök oförglömligt.",
      "thumbnailDescription": "Upplev hantverk och kultur i Reijmyre Glasbruk, en pärla i Östergötland.",
      "additionalText": "<p>Reijmyre Glasbruk erbjuder en unik möjlighet att se traditionellt glasblåseri i aktion. Vår butik har ett brett sortiment av handgjorda glasprodukter, perfekta som gåvor eller som en speciell detalj i ditt hem. Förutom glasblåsning kan du delta i olika kulturella evenemang och samarbeten med lokala konstnärer och hantverkare. Oavsett om du är en konstälskare eller bara söker en trevlig utflykt, kommer Reijmyre Glasbruk att ge dig en oförglömlig upplevelse.</p>",
      "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1074/tags/karta.jpg",
      "thumbnailUrl": "https://storage.googleapis.com/gecko-media/EC_1074/tags/karta.jpg",
      "order": 4,
      "metaTitle": "Upptäck Reijmyre Glasbruk: En Hantverksby i Östergötland",
      "metaDescription": "Besök Reijmyre Glasbruk och upplev glashyttans magi i hjärtat av Östergötlands natur. Utforska vårt unika sortiment och njut av kulturella upplevelser och lokala samarbeten.",
      "metaHeader": "Välkommen till Reijmyre Glasbruk",
      "subCategories": null
    },
    {
      "id": "68625930b32adf555dd37e92",
      "name": "Öppettider & Kontakt",
      "slug": "oppettider-kontakt",
      "description": "Har du frågor eller vill planera ditt besök? Hör gärna av dig till oss – vi hjälper dig med öppettider, bokningar och allt du behöver veta inför ditt besök på Reijmyre Glasbruk.",
      "thumbnailDescription": "Få hjälp med att planera ditt besök på Reijmyre Glasbruk.",
      "additionalText": "<p>Reijmyre Glasbruk är en plats där tradition och hantverk möts. Vi ser fram emot att välkomna dig och hjälpa dig med all information du behöver för att göra ditt besök minnesvärt. Oavsett om du har frågor om våra produkter, vill boka en rundtur eller behöver veta våra öppettider, är vi här för att hjälpa dig. Tveka inte att kontakta oss för att få den bästa upplevelsen av ditt besök.</p>",
      "imgUrl": "https://storage.googleapis.com/gecko-media/EC_1074/tags/Bruket utsida .jpg",
      "thumbnailUrl": null,
      "order": 5,
      "metaTitle": "Planera ditt besök på Reijmyre Glasbruk",
      "metaDescription": "Kontakta oss för att få information om öppettider, bokningar och allt du behöver veta inför ditt besök på Reijmyre Glasbruk.",
      "metaHeader": "Kontakta Reijmyre Glasbruk",
      "subCategories": null
    },
    {
      "id": "6a105d8f4e2bda21866c57c2",
      "name": "Kalender",
      "slug": "kalender",
      "description": null,
      "thumbnailDescription": null,
      "additionalText": null,
      "imgUrl": null,
      "thumbnailUrl": null,
      "order": 6,
      "metaTitle": null,
      "metaDescription": null,
      "metaHeader": null,
      "subCategories": null
    },
    {
      "id": "6a105dae4e2bda21866c57c3",
      "name": "Vintage",
      "slug": "vintage",
      "description": null,
      "thumbnailDescription": null,
      "additionalText": null,
      "imgUrl": null,
      "thumbnailUrl": null,
      "order": 7,
      "metaTitle": null,
      "metaDescription": null,
      "metaHeader": null,
      "subCategories": null
    }
  ],
  "analytics": {
    "gtmId": "GTM-W22M694G",
    "destinations": [
      {
        "type": "GTM",
        "id": "GTM-NBW3NCS2",
        "customMapping": null
      }
    ]
  },
  "privacy": {
    "cmpType": "COOKIE_SCRIPT",
    "cmpId": "ffef583bf04e58b29d44eb759f76e4a2"
  },
  "storeType": "B2C",
  "storeDeliveries": [
    {
      "id": "6874f6ba8d30975701f84b5c",
      "name": "Leverans 2-4 dagar",
      "label": "Leverans 2-4 dagar",
      "buyable": true
    },
    {
      "id": "68c7f86281b5ac54207f778a",
      "name": "Finns ej i lager",
      "label": "Finns ej i lager",
      "buyable": false
    }
  ],
  "language": "sv",
  "currency": "SEK",
  "labels": {
    "currency": "SEK",
    "priceCurrency": "SEK"
  },
  "paths": {
    "brandsUrlPath": "/brands",
    "categoriesUrlPath": "/categories",
    "tagsUrlPath": "/tags",
    "productsUrlPath": "/products",
    "blogsUrlPath": "/blog"
  },
  "staticLinks": [],
  "logoUrl": "https://storage.googleapis.com/gecko-media/EC_1074/logo/Reijmyre%20logo%20black.png",
  "showCart": true,
  "sortingOptions": [
    {
      "sortBy": "price",
      "sortOrder": "DESC",
      "sortLabel": "Pris högt-lågt",
      "default": false
    },
    {
      "sortBy": "price",
      "sortOrder": "ASC",
      "sortLabel": "Pris lågt-högt",
      "default": true
    },
    {
      "sortBy": "created",
      "sortOrder": "DESC",
      "sortLabel": "Nyaste",
      "default": false
    }
  ],
  "desktopItemHeight": "20vw",
  "mobileItemHeight": "75vw",
  "maxContentWidth": 1270,
  "menuMaxContentWidth": 1270,
  "sliderDefaultValues": [
    0,
    10000
  ],
  "freeShippingOver": 1000,
  "shippingProviderConfig": {
    "provider": "NSHIFT",
    "simpleShipping": {
      "minimumOrderAmountForFreeDelivery": 1000,
      "deliveryFee": 75
    },
    "nshiftOptions": {
      "availableCountries": [
        "SE"
      ]
    }
  },
  "paymentProviderConfig": {
    "providerName": "NEXI",
    "providerOptions": {
      "nexi": {
        "purchaseCurrency": "SEK",
        "countryCode": "SWE",
        "showMerchantName": null,
        "showOrderSummary": null,
        "completePaymentButtonText": null,
        "termsUrl": "/kopvillkor",
        "cancellationTermsUrl": null
      }
    }
  },
  "filtersBeforeShowMore": 3,
  "sliderMaxPrice": 10000,
  "topNavHeight": {
    "panel": {
      "base": 0,
      "sm": "5vh"
    },
    "content": {
      "base": "8vh",
      "sm": "14vh"
    },
    "spacer": {
      "base": "8vh",
      "sm": "19vh"
    }
  },
  "topNavSlideOutFeaturedCategories": 3,
  "socialMediaItems": [],
  "topNavPanel": {
    "items": []
  },
  "menuCategoriesConfig": {
    "desktop": {
      "variant": "multi-column"
    },
    "mobile": {
      "variant": "multi-column"
    }
  },
  "fonts": {
    "heading": "Playfair_Display",
    "body": "Libre_Baskerville",
    "slogan": "Grape_Nuts"
  }
};
export const serverTheme = {
  "components": {
    "Button": {
      "baseStyle": {
        "borderRadius": "full",
        "backgroundColor": "#5a0204",
        "size": "sm",
        "color": "text.light",
        "fontWeight": "medium",
        "minW": 140,
        "outlineOffset": 0,
        "transition": "all 0.35s cubic-bezier(.08,.52,.52,1)"
      }
    },
    "CustomFooter": {
      "bg": "#FFFFFF",
      "textColor": "#000000"
    },
    "GrandOverlay": {
      "bg": "rgba(0,0,0, 0.25)"
    },
    "TopNavLogo": {
      "w": "7vh",
      "h": "7vh"
    },
    "FooterLogo": {
      "h": "7rem",
      "w": "7rem"
    },
    "ProductDeliveryGuaranty": {
      "display": "none"
    },
    "ProductDeliveryInstallation": {
      "display": "none"
    }
  },
  "colors": {
    "primary": "#5a0204",
    "secondary": "#E6E6E6",
    "klarna": "#315D91",
    "background": {
      "default": "#FFF",
      "surface": "#FFFFFF",
      "mildDark": "rgb(1,50,75)",
      "dark": "rgb(0,25,38)",
      "darkest": "rgb(0,19,28)",
      "translucent": "#FFFFFF",
      "overlayHalf": "rgba(0,0,0, 0.25)",
      "overlay": "rgba(0,0,0, 0.5)",
      "primary": "rgba(146,176,156, .1)",
      "secondary": "rgba(205,15,50, .1)"
    },
    "text": {
      "default": "#212626",
      "disabled": "#9DB1BC",
      "mild": "#5A7A84",
      "light": "white",
      "darkGrey": "#323a3a",
      "colored": "#315d91"
    },
    "status": {
      "success": "rgba(29,195,149, 1)",
      "warning": "#eed892",
      "warning2": "#f5e6d6",
      "error": "#f35f5f"
    },
    "brand": {
      "10": "#eaebef",
      "50": "#D4DDE3",
      "100": "#C2CED6",
      "200": "#AFC0C9",
      "300": "#9DB1BC",
      "400": "#7B95A0",
      "500": "#5A7A84",
      "600": "#4B6D76",
      "700": "#3C6068",
      "800": "#1F464C",
      "900": "#0A2D31",
      "1000": "#323a3a",
      "1100": "#212626",
      "darkExtraLight": "rgba(0,25,38,0.20)",
      "darkGrey": "#222222"
    },
    "component": {
      "TopNavContent": {
        "hamburger": {
          "color": "#000000"
        },
        "MenuItem": {
          "color": "#000000",
          "_menuIsOpened": {
            "color": "#d5bf97"
          },
          "_active": {
            "color": "#d5bf97"
          },
          "_active_menuIsOpened": {
            "color": "#d5bf97"
          }
        }
      }
    }
  }
}; 
